import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Select } from 'src/domains/layouts/shared/formComponents/Select/components/new/Select';
import { LanguagesState } from 'src/AppState/CmsState/LanguagesState/LanguagesState';
import { LanguageSelectState } from 'src/domains/layouts/shared/formComponents/Select/components/new/LanguageSelectState';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { InputLabel } from 'src/domains/layouts/shared/formComponents/FormComponents.style';
import {
    AddTranslationButton,
    CmsTranslationsFormWrapper,
    DeleteWrapper,
    DisplayedLanguage,
    SelectLabelWrapper,
} from 'src/domains/layouts/shared/cms/translationsForm/CmsTranslationsForm.style';
import { TrashIconWrapper } from 'src/domains/layouts/shared/GlobalStyles.style';
import { Popup } from 'src/domains/layouts/shared/popup/Popup';
import { DeletePopup } from 'src/domains/layouts/shared/popup/popups/cms/DeletePopup';
import { OptionType } from 'src/AppState/ConfigState/types';

interface PropsType {
    languagesState: LanguagesState;
    formLanguage: FormInputState<string, string>;
    isModifyMode: boolean;
    handleDelete: (lang: string) => Promise<void>;
    onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    showButton: boolean;
    isDisabled: boolean;
    isNewForm: boolean;
    children: React.ReactNode;
    allSelectedLanguages: Array<OptionType>;
    setSelectedLanguages: (newSelectedLanguages: Array<OptionType>) => void;
    handleShowDeletePopup: () => void;
    handleHideDeletePopup: () => void;
    showDeletePopup: boolean;
}

export const CmsTranslationsForm = observer(
    ({
        formLanguage,
        languagesState,
        isModifyMode,
        isNewForm,
        handleDelete,
        onClick,
        showButton,
        isDisabled,
        children,
        allSelectedLanguages,
        setSelectedLanguages,
        handleShowDeletePopup,
        handleHideDeletePopup,
        showDeletePopup,
    }: PropsType) => {
        const [languageSelectState] = useState(
            () =>
                new LanguageSelectState(languagesState, formLanguage, () => allSelectedLanguages, setSelectedLanguages)
        );

        const { availableOptions, onChangeLanguage, displayedLanguage } = languageSelectState;

        const hideSelect = isModifyMode && isNewForm === false;

        return (
            <CmsTranslationsFormWrapper>
                <SelectLabelWrapper>
                    <InputLabel isEmpty={formLanguage.value === ''}>
                        {hideSelect ? <DisplayedLanguage>{displayedLanguage}</DisplayedLanguage> : 'Select language'}
                    </InputLabel>
                    <DeleteWrapper onClick={handleShowDeletePopup}>
                        Delete
                        <TrashIconWrapper />
                    </DeleteWrapper>
                </SelectLabelWrapper>

                {hideSelect ? null : (
                    <Select
                        placeholder='-Select-'
                        stateValue={formLanguage}
                        selectOptions={availableOptions}
                        onChangeCB={onChangeLanguage}
                    />
                )}

                {children}

                {showButton ? (
                    <AddTranslationButton
                        addAnotherForm={true}
                        isDisabled={isDisabled}
                        version='secondary'
                        width='full'
                        onClick={onClick}
                    >
                        Add another language
                    </AddTranslationButton>
                ) : null}

                {showDeletePopup === false ? null : (
                    <Popup
                        width={384}
                        handleHidePopup={handleHideDeletePopup}
                    >
                        <DeletePopup
                            handleDelete={(): Promise<void> => handleDelete(formLanguage.value)}
                            handleHidePopup={handleHideDeletePopup}
                        />
                    </Popup>
                )}
            </CmsTranslationsFormWrapper>
        );
    }
);
